import { Table } from 'rbx';
import * as React from 'react';

import IndexDocumentMutation from './IndexDocumentMutation';

export interface IIndeaxable {
    indexedCount: number;
    indexableCount: number;
    ignoredCount: number;
    errorCount: number;
    name: string;
    type: string;
    query: string;
    sort: number;
    dryRun: boolean;
    forceSplit: boolean;
    onlyErrored: boolean;
    forceOcr: boolean;
    forceIndex: boolean;
    forceNormalize: boolean;
    forceExtract: boolean;
}

interface IProps {
    plantS3Folder: string;
    indexable: IIndeaxable;
}

export class IndexableRow extends React.Component<IProps, any> {
    public render() {
        const { plantS3Folder, indexable } = this.props;
        const hasAction = indexable.name !== 'ignored' && indexable.name !== 'error';

        return (
            <tr>
                <td>{indexable.name} </td>
                <td>{indexable.indexableCount} </td>
                <td>
                    {indexable.indexedCount}
                    {indexable.type === 's3' && (
                        <small>
                            &nbsp;({indexable.ignoredCount} ignored / {indexable.errorCount}&nbsp;
                            errored)
                        </small>
                    )}
                </td>
                <td>
                    {hasAction && (
                        <>
                            {indexable.type === 's3' && (
                                <IndexDocumentMutation
                                    indexable={indexable}
                                    plantS3Folder={plantS3Folder}
                                />
                            )}
                        </>
                    )}
                </td>
            </tr>
        );
    }
}
